import { useFeatureFlag } from '../../../utils/feature-flag';

export const ASK_CROSS_SELL_FEATURE_FLAG = 'ask.cross_sell';

export function useIsAskCrossSell(): boolean | undefined {
  return useFeatureFlag(ASK_CROSS_SELL_FEATURE_FLAG);
}
